// Vaanmathi
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import idlbay from "../../assets/idlbay.png";
import { showMyAlert } from "../../Utils/alertService";

const SignInPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    mobileNumber: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);


  useEffect(() => {
    const autoLoginData = localStorage.getItem("autoLoginData");
    const showAutoLoginAlert = localStorage.getItem("showAutoLoginAlert");

    if (autoLoginData && showAutoLoginAlert === "true") {
      try {
        const data = JSON.parse(autoLoginData);
        setFormData({
          mobileNumber: data.mobileNumber || "",
          password: data.password || "",
        });
        setTimeout(() => {
          showMyAlert({
            type: "success",
            title: "Welcome!",
            message: "Registration successful! Auto-logging you in...",
            duration: 3000,
          });

          localStorage.removeItem("autoLoginData");
          localStorage.removeItem("showAutoLoginAlert");

          performAutoLogin(data.mobileNumber, data.password);
        }, 800);

      } catch (error) {
        console.error("Auto-login error:", error);
        localStorage.removeItem("autoLoginData");
        localStorage.removeItem("showAutoLoginAlert");
      }
    }
  }, []);

  const getDemoStartDate = (demoRegDate, demoRegTime) => {
    if (!demoRegDate) return null;

    const [day, month, year] = demoRegDate.split("-").map(Number);
    const [hours = 0, minutes = 0, seconds = 0] = (demoRegTime || "00:00:00")
      .split(":")
      .map(Number);

    const d = new Date(year, month - 1, day, hours, minutes, seconds);
    return isNaN(d.getTime()) ? null : d;
  };

  const hasTrialExpired = (demoRegDate, demoRegTime) => {
    const start = getDemoStartDate(demoRegDate, demoRegTime);
    if (!start) return false;
    console.log("false not hit");

    const now = new Date();
    const diffMs = now.getTime() - start.getTime();
    const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
    console.log(diffMs, sevenDaysMs);

    return diffMs >= sevenDaysMs;
  };


  const colors = {
    primary: "#ff4444",
    primaryDark: "#e63946",
    primaryLight: "#ff6b6b",
    primaryLighter: "#ffb3b3",
    secondary: "#ff8a80",
    accent: "#ff5722",
    background: "#fff8f7",
    backgroundGradient:
      "linear-gradient(135deg, #fff8f7 0%, #ffe8e6 50%, #ffddd8 100%)",
    text: "#2d1b20",
    textLight: "#5a4349",
    textMuted: "#8a6b73",
    border: "#ffcdd2",
    error: "#d32f2f",
    errorBg: "#ffebee",
    white: "#ffffff",
    black: "#000000",
    success: "#4caf50",
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (error) {
      setError("");
    }
  };

  const validateForm = () => {
    if (!formData.mobileNumber.trim()) {
      setError("Mobile number is required");
      showMyAlert({
        type: "warning",
        title: "Validation Error",
        message: "Mobile number is required",
        duration: 5000,
      })
      return false;
    }
    if (!formData.password.trim()) {
      setError("Password is required");
      showMyAlert({
        type: "warning",
        title: "Validation Error",
        message: "Password is required",
        duration: 5000,
      })
      return false;
    }
    if (formData.mobileNumber.trim().length < 10) {
      setError("Please enter a valid mobile number");
      showMyAlert
        ({
          type: "warning",
          title: "Validation Error",
          message: "Please enter a valid mobile number",
          duration: 5000,
        })
      return false;
    }
    return true;
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await fetch(
        "https://api.dremerz.net/api/DZ_8922_Payroll_PayrollCreateAdmin_PayrollAdminList",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      const adminList = Array.isArray(data) ? data : [data];

      const user = adminList.find(
        (admin) => admin.mobileNumber === formData.mobileNumber
      );
      if (!user) {
        setError("No admin account found with this mobile number.");
        showMyAlert({
          type: "danger",
          title: "Login Failed",
          message: "No admin account found with this mobile number.",
          duration: 5000,
        });
        return;
      }
      if (user.password !== formData.password) {
        setError("Incorrect password. Please check and try again.");
        showMyAlert({
          type: "danger",
          title: "Login Failed",
          message: "Incorrect password. Please check and try again.",
          duration: 5000,
        });
        return;
      }
      if ((user.status || "").toLowerCase() !== "active") {
        setError("Your account is inactive. Please contact the super admin.");
        showMyAlert({
          type: "warning",
          title: "Account Inactive",
          message: "Your account is inactive. Please contact the super admin.",
          duration: 5000,
        });
        return;
      }
      if ((user.status || "").toLowerCase() !== "active") {
        setError("Your account is inactive. Please contact the super admin.");
        showMyAlert({
          type: "warning",
          title: "Account Inactive",
          message: "Your account is inactive. Please contact the super admin.",
          duration: 5000,
        });
        return;
      }
      if (hasTrialExpired(user.demoRegDate, user.demoRegTime) && user.accountStatus === "freeTrail") {
        setError("Your trial period ended. Book a demo or contact us to continue.");
        showMyAlert({
          type: "warning",
          title: "Trial Expired",
          message: "Your trial period ended. Book a demo or contact us to continue.",
          duration: 7000,
        });
        return;
      }

      showMyAlert({
        type: "success",         
        title: "success",
        message: "Logged in Successfully",
        duration: 2500,           
      });

      const userData = {
        id: user.id,
        userName: user.userName,
        fullName: user.fullName,
        email: user.email,
        mobileNumber: user.mobileNumber,
        role: user.role,
        dateOfJoining: user.dateOfJoining,
      };

      // Save to localStorage
      localStorage.setItem("userId", user.id);
      localStorage.setItem("userName", user.userName);
      localStorage.setItem("userMobile", user.mobileNumber);
      localStorage.setItem("role", user.role);
      localStorage.setItem("userEmail", user.email);
      localStorage.setItem("userFullName", user.fullName);
      localStorage.setItem("companyKey", user.companyKey)

      // Save to sessionStorage
      sessionStorage.setItem("userId", user.id);
      sessionStorage.setItem("userName", user.userName);
      sessionStorage.setItem("userMobile", user.mobileNumber);
      sessionStorage.setItem("role", user.role);
      sessionStorage.setItem("userEmail", user.email);
      sessionStorage.setItem("userFullName", user.fullName);
      sessionStorage.setItem("companyKey", user.companyKey);

      setSuccess("Login successful! Redirecting...");
      showMyAlert({
        type: "success",
        title: "Success",
        message: "Login successful! Redirecting...",
        duration: 2500,
      });
      setTimeout(() => {
        navigate("/LandingPage");
      }, 3000);
    } catch (error) {
      console.error("Login error:", error);
      setError("Unable to connect to server. Please try again later.");

      showMyAlert({
        type: "danger",
        title: "Error",
        message: "Unable to connect to server. Please try again later.",
        duration: 2500,
      });
    } finally {
      setLoading(false);
    }
  };


  const performAutoLogin = async (mobileNumber, password) => {
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await fetch(
        "https://api.dremerz.net/api/DZ_8922_Payroll_PayrollCreateAdmin_PayrollAdminList",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      const adminList = Array.isArray(data) ? data : [data];
      const user = adminList.find(
        (admin) => admin.mobileNumber === mobileNumber
      );
      if (!user) {
        setError("No admin account found with this mobile number.");
        showMyAlert({
          type: "danger",
          title: "Login Failed",
          message: "No admin account found with this mobile number.",
          duration: 5000,
        });
        setLoading(false);
        return;
      }
      if (user.password !== password) {
        setError("Incorrect password. Please check and try again.");
        showMyAlert({
          type: "danger",
          title: "Login Failed",
          message: "Incorrect password. Please check and try again.",
          duration: 5000,
        });
        setLoading(false);
        return;
      }
      if ((user.status || "").toLowerCase() !== "active") {
        setError("Your account is inactive. Please contact the super admin.");
        showMyAlert({
          type: "warning",
          title: "Account Inactive",
          message: "Your account is inactive. Please contact the super admin.",
          duration: 5000,
        });
        setLoading(false);
        return;
      }
      if (hasTrialExpired(user.demoRegDate, user.demoRegTime) && user.accountStatus === "freeTrail") {
        setError("Your trial period ended. Book a demo or contact us to continue.");
        showMyAlert({
          type: "warning",
          title: "Trial Expired",
          message: "Your trial period ended. Book a demo or contact us to continue.",
          duration: 7000,
        });
        setLoading(false);
        return;
      }
      console.log("Login successful:", user);
      showMyAlert({
        type: "success",
        title: "success",
        message: "Logged in Successfully",
        duration: 2500,
      });

      const userData = {
        id: user.id,
        userName: user.userName,
        fullName: user.fullName,
        email: user.email,
        mobileNumber: user.mobileNumber,
        role: user.role,
        dateOfJoining: user.dateOfJoining,
      };

      localStorage.setItem("userId", user.id);
      localStorage.setItem("userName", user.userName);
      localStorage.setItem("userMobile", user.mobileNumber);
      localStorage.setItem("role", user.role);
      localStorage.setItem("userEmail", user.email);
      localStorage.setItem("userFullName", user.fullName);
      localStorage.setItem("companyKey", user.companyKey)

      sessionStorage.setItem("userId", user.id);
      sessionStorage.setItem("userName", user.userName);
      sessionStorage.setItem("userMobile", user.mobileNumber);
      sessionStorage.setItem("role", user.role);
      sessionStorage.setItem("userEmail", user.email);
      sessionStorage.setItem("userFullName", user.fullName);
      sessionStorage.setItem("companyKey", user.companyKey);

      setSuccess("Login successful! Redirecting...");
      showMyAlert({
        type: "success",
        title: "Success",
        message: "Login successful! Redirecting...",
        duration: 2500,
      });
      setTimeout(() => {
        navigate("/LandingPage");
      }, 3000);
    } catch (error) {
      console.error("Login error:", error);
      setError("Unable to connect to server. Please try again later.");

      showMyAlert({
        type: "danger",
        title: "Error",
        message: "Unable to connect to server. Please try again later.",
        duration: 2500,
      });
      setLoading(false);
    }
  };


  return (
    <div
      style={{
        minHeight: "100vh",
        // background: colors.backgroundGradient,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "10%",
          left: "10%",
          width: "300px",
          height: "200px",
          background: "linear-gradient(135deg, #ff7b7b, #ff9a56)",
          borderRadius: "50%",
          opacity: "0.3",
          filter: "blur(40px)",
          zIndex: 1,
        }}
      ></div>

      <div
        style={{
          position: "absolute",
          bottom: "20%",
          right: "10%",
          width: "200px",
          height: "200px",
          background: "linear-gradient(135deg, #4ecdc4, #44a08d)",
          borderRadius: "50%",
          opacity: "0.3",
          filter: "blur(40px)",
          zIndex: 1,
        }}
      ></div>

      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          position: "relative",
          zIndex: 2,
        }}
      >
        <div
          style={{
            backgroundColor: colors.white,
            borderRadius: "24px",
            boxShadow: `0 25px 50px -12px rgba(255, 68, 68, 0.15)`,
            overflow: "hidden",
          }}
        >
          <div className="row g-0">
            {/* Left Side - Sign In Form */}
            <div className="col-lg-6">
              <div style={{ padding: "3rem" }}>
                {/* Header with Logo and Smart Sign-in Button */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginBottom: "2rem",
                  }}
                  className="justify-content-center justify-content-md-between"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <img
                      src={idlbay}
                      alt="IDLBAY Logo"
                      style={{
                        width: "200px",
                        height: "80px",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: colors.white,
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      backgroundColor: colors.primary,
                      color: colors.white,
                      fontSize: "0.875rem",
                      padding: "0.5rem 1rem",
                      borderRadius: "9999px",
                      border: `1px solid ${colors.primaryLight}`,
                      fontWeight: "500",
                    }}
                  >
                    <span>🔐</span>
                    <span>Secure Login Portal</span>
                  </div>
                </div>

                {/* Sign In Title */}
                <div style={{ marginBottom: "2rem" }}>
                  <h1
                    style={{
                      fontSize: "1.875rem",
                      fontWeight: "bold",
                      color: colors.text,
                      marginBottom: "0.5rem",
                    }}
                  >
                    Sign in
                  </h1>
                  <p
                    style={{
                      color: colors.textMuted,
                      fontSize: "0.875rem",
                      margin: 0,
                    }}
                  >
                    to access IDLBAY payroll
                  </p>
                </div>


                <form onSubmit={handleSignIn}>
                  {/* Mobile Number Input */}
                  <div style={{ marginBottom: "1.5rem" }}>
                    <input
                      type="tel"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleInputChange}
                      placeholder="Enter Mobile Number"
                      style={{
                        width: "100%",
                        padding: "1rem 1.25rem",
                        backgroundColor: colors.background,
                        border:
                          error && !formData.mobileNumber
                            ? `2px solid ${colors.error}`
                            : `1px solid ${colors.border}`,
                        borderRadius: "0.5rem",
                        color: colors.text,
                        fontSize: "1rem",
                        outline: "none",
                        transition: "border-color 0.2s",
                      }}
                      onFocus={(e) =>
                        (e.target.style.borderColor = colors.primary)
                      }
                      onBlur={(e) =>
                        (e.target.style.borderColor = colors.border)
                      }
                      disabled={loading}
                    />
                  </div>

                  {/* Password Input */}
                  <div style={{ marginBottom: "1.5rem", position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      placeholder="Enter Password"
                      style={{
                        width: "100%",
                        padding: "1rem 1.25rem",
                        backgroundColor: colors.background,
                        border:
                          error && !formData.password
                            ? `2px solid ${colors.error}`
                            : `1px solid ${colors.border}`,
                        borderRadius: "0.5rem",
                        color: colors.text,
                        fontSize: "1rem",
                        outline: "none",
                        transition: "border-color 0.2s",
                      }}
                      onFocus={(e) =>
                        (e.target.style.borderColor = colors.primary)
                      }
                      onBlur={(e) =>
                        (e.target.style.borderColor = colors.border)
                      }
                      disabled={loading}
                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: "18px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: colors.textMuted,
                        fontSize: "1.25rem",
                        zIndex: 2,
                      }}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      <i
                        className={`fa${showPassword ? "s" : "r"} fa-eye${showPassword ? "-slash" : ""
                          }`}
                      ></i>
                    </span>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      width: "100%",
                      background: loading
                        ? colors.textMuted
                        : `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
                      color: colors.white,
                      fontWeight: "600",
                      padding: "1rem 1.5rem",
                      borderRadius: "0.5rem",
                      border: "none",
                      marginBottom: "2rem",
                      transition: "all 0.3s ease",
                      cursor: loading ? "not-allowed" : "pointer",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "0.5rem",
                      boxShadow: loading
                        ? "none"
                        : `0 4px 15px rgba(255, 68, 68, 0.3)`,
                    }}
                    onMouseOver={(e) => {
                      if (!loading) {
                        e.target.style.background = `linear-gradient(135deg, ${colors.primaryLight} 0%, ${colors.primary} 100%)`;
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = `0 6px 20px rgba(255, 68, 68, 0.4)`;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (!loading) {
                        e.target.style.background = `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`;
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = `0 4px 15px rgba(255, 68, 68, 0.3)`;
                      }
                    }}
                  >
                    {loading ? (
                      <>
                        <div
                          style={{
                            width: "16px",
                            height: "16px",
                            border: `2px solid ${colors.white}`,
                            borderTopColor: "transparent",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        ></div>
                        <span>Signing in...</span>
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </button>
                </form>

                {/* Sign Up Link */}
                <p
                  style={{
                    textAlign: "center",
                    color: colors.textMuted,
                    fontSize: "0.875rem",
                    margin: 0,
                  }}
                >
                  Don't have a Payroll account?{" "}
                  <button
                    className="bg-transparent border-0 p-0"
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      color: colors.primary,
                      fontWeight: "500",
                    }}
                    onClick={() => navigate("/RegisterPage")}
                  >
                    Sign Up
                  </button>
                </p>
              </div>
            </div>

            {/* Right Side - Illustration */}
            <div className="col-lg-6">
              <div
                style={{
                  background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 25%, ${colors.accent} 75%, ${colors.primaryLight} 100%)`,
                  padding: "3rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "100%",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Background Pattern */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                              radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                              radial-gradient(circle at 40% 60%, rgba(255, 255, 255, 0.05) 0%, transparent 50%)`,
                    pointerEvents: "none",
                  }}
                ></div>

                <div
                  style={{
                    textAlign: "center",
                    color: colors.white,
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  {/* Main Illustration */}
                  <div
                    style={{
                      position: "relative",
                      marginBottom: "2rem",
                      margin: "0 auto 2rem auto",
                      width: "280px",
                      height: "200px",
                      backgroundColor: "rgba(255, 255, 255, 0.15)",
                      borderRadius: "20px",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {/* Laptop Screen */}
                    <div
                      style={{
                        position: "relative",
                        width: "220px",
                        height: "150px",
                        backgroundColor: colors.white,
                        borderRadius: "12px",
                        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "20px",
                          left: "20px",
                          right: "20px",
                          bottom: "20px",
                          background: `linear-gradient(135deg, ${colors.background}, ${colors.white})`,
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div style={{ textAlign: "center" }}>
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              backgroundColor: colors.primary,
                              borderRadius: "50%",
                              margin: "0 auto 12px auto",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: `0 4px 15px rgba(255, 68, 68, 0.3)`,
                            }}
                          >
                            <span
                              style={{ color: colors.white, fontSize: "1rem" }}
                            >
                              👤
                            </span>
                          </div>
                          <div
                            style={{
                              fontSize: "0.75rem",
                              color: colors.textLight,
                              fontWeight: "600",
                              marginBottom: "8px",
                            }}
                          >
                            admin@idlbay.com
                          </div>
                          <div
                            style={{
                              width: "60px",
                              height: "4px",
                              backgroundColor: colors.primary,
                              borderRadius: "2px",
                              margin: "0 auto",
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>

                    {/* Floating Icons */}
                    <div
                      style={{
                        position: "absolute",
                        top: "-12px",
                        right: "-12px",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(5px)",
                        border: "1px solid rgba(255, 255, 255, 0.3)",
                      }}
                    >
                      <span style={{ color: colors.white, fontSize: "1rem" }}>
                        💼
                      </span>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        bottom: "-12px",
                        left: "-12px",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(5px)",
                        border: "1px solid rgba(255, 255, 255, 0.3)",
                      }}
                    >
                      <span style={{ color: colors.white, fontSize: "1rem" }}>
                        📊
                      </span>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "-20px",
                        transform: "translateY(-50%)",
                        width: "32px",
                        height: "32px",
                        backgroundColor: "rgba(255, 255, 255, 0.15)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(5px)",
                      }}
                    >
                      <span
                        style={{ color: colors.white, fontSize: "0.875rem" }}
                      >
                        🔒
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <h2
                    style={{
                      fontSize: "1.75rem",
                      fontWeight: "bold",
                      marginBottom: "1rem",
                      textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    Welcome to IDLBAY
                  </h2>
                  <p
                    style={{
                      color: "rgba(255, 255, 255, 0.95)",
                      marginBottom: "2rem",
                      lineHeight: "1.6",
                      fontSize: "1rem",
                    }}
                  >
                    Your trusted partner for comprehensive payroll management.
                    Streamline your HR processes with our secure and efficient
                    platform.
                  </p>

                  <div
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      color: colors.white,
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      padding: "0.75rem 2rem",
                      borderRadius: "9999px",
                      fontSize: "0.875rem",
                      fontWeight: "600",
                      cursor: "default",
                      backdropFilter: "blur(5px)",
                      display: "inline-block",
                    }}
                  >
                    ✨ Get Started Today
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
          <p
            style={{
              color: colors.black,
              fontSize: "0.75rem",
              margin: 0,
            }}
          >
            © 2025, IDLBAY Pvt. Ltd. All Rights Reserved.
          </p>
        </div>
      </div>

      {/* Loading Spinner CSS */}
      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default SignInPage;
